module.exports = __webpack_public_path__ + "img/pazarcloud-main-card.3e56f819.jpg";